module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"section":{"title":"特別授業"}}}')
  delete Component.options._Ctor
}
